import "./FooterStyle.css";
import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <div className='social'>
            <div className='socialLink'>
                <div className='linkedIn'><Link to="https://www.linkedin.com/in/iamrishav/" target={'_blank'}><i class="fa-brands fa-linkedin"></i></Link></div>
                <div className='twitter'><Link to="https://twitter.com/im_rishav_kr" target={'_blank'}><i class="fa-brands fa-square-twitter"></i></Link></div>
                <div className='twitter'><Link to="https://github.com/rishav812" target={'_blank'}><i class="fa-brands fa-github"></i></Link></div>
            </div>
            <p>Copyright &copy; Rishav's Website 2023</p>
        </div>
    )
}
export default Footer;